<template>
	<div class="">
		<div class="mb-4 animated-background fake-content-header-small-half"></div>
		<div class="animated-background art-image"></div>
	</div>
</template>

<script>
	export default {
		name: 'Article'
	}
</script>


// WEBPACK FOOTER //
// src/components/frontend/content_placeholders/Article.vue